import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useSectionAdmin from "./hooks/useSectionAdmin";

import SectionAdminStats from "./components/SectionAdminStats";
import SectionAdminToolbar from "./components/SectionAdminToolbar";
import SectionAdminTable from "./components/SectionAdminTable";
import SectionFormDrawer from "./components/SectionFormDrawer";

export default function SectionAdmin() {
  useScrollToTop();

  const {
    categories,
    categoriesById,
    loading,
    saving,
    categorySaving,
    stats,
    query,
    selectedCategory,
    selectedStatus,
    visibleSections,
    filteredSections,
    visibleCount,
    drawer,
    demoMode,

    setQuery,
    setSelectedCategory,
    setSelectedStatus,
    resetFilters,
    loadMore,
    refreshData,

    openCreateDrawer,
    openEditDrawer,
    closeDrawer,
    handleCreateCategory,
    handleCreateSection,
    handleUpdateSection,
    handleDeleteSection,
    handleDeleteCategory,
  } = useSectionAdmin();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1500px] space-y-5">
        <SectionAdminToolbar
          query={query}
          selectedCategory={selectedCategory}
          selectedStatus={selectedStatus}
          categories={categories}
          loading={loading}
          demoMode={demoMode}
          onQueryChange={setQuery}
          onCategoryChange={setSelectedCategory}
          onStatusChange={setSelectedStatus}
          onReset={resetFilters}
          onRefresh={refreshData}
          onCreate={openCreateDrawer}
        />

        <SectionAdminStats stats={stats} />

        <SectionAdminTable
          sections={visibleSections}
          categoriesById={categoriesById}
          loading={loading}
          totalRows={filteredSections.length}
          visibleCount={visibleCount}
          demoMode={demoMode}
          onLoadMore={loadMore}
          onEdit={openEditDrawer}
          onDelete={handleDeleteSection}
        />
      </div>

      <SectionFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        categories={categories}
        saving={saving}
        categorySaving={categorySaving}
        onClose={closeDrawer}
        onCreate={handleCreateSection}
        onCreateCategory={handleCreateCategory}
        onDeleteCategory={handleDeleteCategory}
      />

      <SectionFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        section={drawer.section}
        categories={categories}
        saving={saving}
        categorySaving={categorySaving}
        onClose={closeDrawer}
        onUpdate={handleUpdateSection}
        onCreateCategory={handleCreateCategory}
        onDeleteCategory={handleDeleteCategory}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}
